exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-12[data-v-75d893d0]{\n    text-align: center;\n}\n.col-md-6[data-v-75d893d0]{\n    display: inline-block;\n    width: 49%;\n}\n.row[data-v-75d893d0]{\n\t\tmargin: 20px 0;\n}\n.justify-content-center[data-v-75d893d0]{\n\t\tmargin-right: -15px;\n\t\tmargin-left: -15px;\n}\n", ""]);

// exports
